<template>
  <v-row class="mt-5" justify="center">
    <v-card
      width="100%"
      elevation="11"
      class="mx-auto
      entry-container"
    >
      <v-card-text>
        <div v-if="loading" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <div v-else-if="!dataError && !loading">
          <b-row class="d-flex justify-center text-center bespoke-margin"
            ><h2 class="p-0 m-0"><u>Booking Confirmation</u></h2></b-row
          >
          <b-row class="mt-4 text-center bespoke-margin">
            <b-col cols="3"></b-col>
            <b-col cols="6">
              <p class="success-p">
                Name: <b>{{ apptData.customer_data.name }}</b>
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center bespoke-margin">
            <b-col cols="3"></b-col>
            <b-col cols="6"
              ><p class="success-p">
                Date:
                <b>
                  {{ formatDate(apptData.start_time, "DD/MM/YYYY") }}
                </b>
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center bespoke-margin">
            <b-col cols="3"></b-col>
            <b-col cols="6"
              ><p class="success-p">
                Start Time:<b>
                  {{ formatDate(apptData.start_time, "HH:mm") }}
                </b>
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center bespoke-margin">
            <b-col cols="3"> </b-col>
            <b-col cols="6">
              <p class="success-p">
                End Time: <b>{{ formatDate(apptData.end_time, "HH:mm") }}</b>
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center bespoke-margin">
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <p class="display-5">
                Thank you for making a booking with Trailfinders Sports Club.<br />
                Email confirmation has been sent to
                <b>{{ apptData.customer_data.email }}</b
                >.<br />
                If you have any queries regarding your booking please contact us
                on <a href="tel:020 8998 79283">020 8998 79283</a>.
              </p>
            </b-col>
          </b-row>
        </div>
        <v-alert
          class="text-center m-1 mb-0"
          color="red"
          :icon="false"
          dark
          type="error"
          dense
          outlined
          v-if="dataError"
        >
          {{ dataErrorMessage }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import {
  getAppt,
  updateAppt,
  getPaymentStatus,
  sendBookingConfirmation
} from "../../services/FacilityService.js";
import moment from "moment";
export default {
  data() {
    return {
      meta: {
        loaded: true,
        title: "TFSC Reservation Booking"
      },
      loading: true,
      errors: [],
      dataSuccess: false,
      dataError: false,
      dataErrorMessage: "",
      mobile: window.innerWidth <= 1200,
      apptData: {
        facilitySubId: "",
        facilitySize: "",
        facilityName: "",
        emails: {
          customer_initial_email: {},
          tf_initial_email: {},
          customer_booked_email: {},
          customer_warning_email: {}
        },
        intNotes: "",
        extNotes: "",
        customer_data: {}
      }
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1200;
    });
  },
  mounted() {
    setTimeout(async () => {
      await this.getAppt();
      await this.getPaymentStatus();
    }, 100);
  },
  methods: {
    async getAppt() {
      try {
        let res = await getAppt(this.$route.params.id);
        if (res.error) {
          this.dataErrorMessage =
            "An internal server error occurred. Please try later.";
          this.dataError = true;
        }
        this.apptData = res;
      } catch (err) {
        this.dataError = true;
      }
    },
    async getPaymentStatus() {
      this.loading = true;
      // let res = { data: "paid", error: false }; SWAP this FOR TESTING PURPOSES TO SKIP payment
      let res = await getPaymentStatus(this.$route.query.session_id);
      if (res.error) {
        this.dataErrorMessage =
          "An internal server error occurred. Please try later.";
      }
      if (res.data && res.data === "paid") {
        this.transactionStatus = res.data;
        this.makeBooking();
      } else {
        this.apptData.transactionStatus = this.transactionStatus;
        this.apptData.transactionId = this.$route.query.session_id;
        let res = await updateAppt({ data: this.apptData, ext: true });
        if (res.status && res.status <= 399) {
          if (res.data.msg) {
            this.loading = false;
          }
        } else {
          this.dataError = true;
          this.loading = false;
          if (res.error) {
            this.dataErrorMessage = res.Message;
          }
        }
      }
    },
    async makeBooking() {
      this.loading = true;
      if (this.apptData.status === "Hold") {
        this.dataSuccess = false;
        this.dataError = false;
        this.apptData.status = "Booked";
        this.apptData.transactionStatus = this.transactionStatus;
        this.apptData.transactionId = this.$route.query.session_id;
        let res = await updateAppt({ data: this.apptData, ext: true });
        if (res.status && res.status <= 399) {
          if (res.data.msg) {
            let emailConf = await sendBookingConfirmation(
              this.$route.params.id,
              { facilityId: this.apptData.facilityId }
            );
            if (emailConf && emailConf.data) {
              this.dataSuccess = true;
              this.loading = false;
            }
          }
        } else {
          this.dataError = true;
          this.loading = false;
          if (res.error) {
            this.dataErrorMessage = res.Message;
          }
        }
      } else {
        this.loading = false;
      }
    },
    formatDate(_val, formatType) {
      if (_val) {
        return moment(String(_val)).utc().format(formatType);
      }
    }
  }
};
</script>
<style scoped>
.success-p {
  margin: 15px;
}
/* .card-body {
  background-color: #c3e6cb;
} */
</style>
